import Component from '../core/Component'

export const defaults = {
    parent: 'toggleParent',
    toggle: null,
}

export default class ClassToggle extends Component {
    constructor(element, options = {}) {
        super(element)

        this.options = {
            ...defaults,
            ...options,
        }

        this.options.toggle = this.element.dataset.componentToggle
    }

    prepare() {
        this.element.addEventListener('click', ::this.handleClick)
    }

    handleClick(event) {
        event.preventDefault()

        const parent = this.element.closest(this.getRef(this.options.parent))

        if (parent && this.options.toggle) {
            parent.classList.toggle(this.options.toggle)
        }
    }
}
